import Vue from 'vue'

export default Vue.component('print-preview', {
  methods: {
    print() {
      window.print()
    },
  },
})
